export class MoreAboutInstaller {
  typeApp: number;
  operatingsystemId: number;
  typefile: number;
  newVersionMessage: string;
  updatedVersionMessage: string;
}
